import { Box } from '@mui/material'
import { useEffect } from 'react'
// import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
// import { useNavigate } from 'react-router-dom'
import SettingsSchoolManagementList from './List'
import { search as searchDistrict } from 'store/settings/district'
import { search as searchCampus } from 'store/settings/campus'
import { search as searchSchools } from 'store/settings/school'

export default function SettingsSchoolManagementListIndex() {
  // const basePath = '/settings/school-management/'
  const dispatch = useDispatch()
  // const { t } = useTranslation()
  // const navigate = useNavigate()

  const districts = useSelector(state => state.settings.district.list)
  const schools = useSelector(state => state.settings.school.list)
  const campuses = useSelector(state => state.settings.campus.list)

  useEffect(() => {
    dispatch(searchDistrict())
    dispatch(searchSchools())
    dispatch(searchCampus())
  }, [dispatch])

  if (!(districts && campuses && schools)) return null

  return (
    <Box sx={{ pt: 2 }} >
        {/* <Stack sx={{ mx: 2 }} flexDirection={'row'} justifyContent={'flex-end'} alignItems={'center'}>
          <Box>
            <Button size="small" variant="contained" color="primary" onClick={() => navigate(`${basePath}district/new`)}>
              {t('Add District')}
            </Button>
          </Box>
        </Stack> */}
        <SettingsSchoolManagementList districts={districts} campuses={campuses} schools={schools} />
    </Box>
  )
}
